import React, { Fragment, useEffect, useState, useContext } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { Spin } from 'antd';

import * as ROUTES from '../constants/routes';
import * as ROLES from '../constants/roles';
import Background from '../assets/images/background.jpg';
import { StoreContext } from '../containers/Store';

const Landing = (props) => {
  const { user: { user: authUser } } = useContext(StoreContext);

  // showLoading only if first connection
  (localStorage.getItem('evidenceB-firstConnection') === null) ? 
    localStorage.setItem('evidenceB-firstConnection', true) :
    localStorage.setItem('evidenceB-firstConnection', false);

  const [showLoading, setShowLoading] = useState((localStorage.getItem('evidenceB-firstConnection')==="true"));

  useEffect(
    () => {
      let timer = setTimeout(() => setShowLoading(false), 3000);
      // this will clear Timeout when component unmont like in willComponentUnmount
      return () => {
        clearTimeout(timer)
      }
    },
    [] // useEffect will run only one time
  );

  return (
    <Fragment>
        <div style={window.innerWidth > 520 ? {
          backgroundImage: `url(${Background})`,
          backgroundRepeat: 'no-repeat',
          height: '80vh',
          maxWidth: '50%',
          margin: 'auto'
        } : null
        }>
          <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', paddingTop: '30%' }}>
            {showLoading && <Spin size='large' />}
            {!showLoading && authUser && authUser.roles.includes(ROLES.STUDENT_DEMO) && <Redirect to={ROUTES.CHATBOT}/>}
            {!showLoading && authUser && authUser.roles.includes(ROLES.TEACHER_DEMO) && <Redirect to={ROUTES.DASHBOARD}/>}
          </div>
        </div>
    </Fragment>
  )
};

export default withRouter(Landing);